import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FreeWifiIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FreeWifiIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M13.9093 14.7696C14.6162 14.0627 14.6163 12.9184 13.9093 12.2114C13.2023 11.5044 12.058 11.5044 11.351 12.2114C10.6441 12.9183 10.644 14.0627 11.351 14.7696C12.058 15.4766 13.2023 15.4767 13.9093 14.7696Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.90306 10.8019C11.4067 9.29819 13.8533 9.29819 15.357 10.8019C15.4697 10.9146 15.6175 10.971 15.7652 10.971C16.2749 10.971 16.5382 10.3502 16.1734 9.98545C14.2196 8.03155 11.0404 8.03155 9.08658 9.98545C8.86112 10.2109 8.86112 10.5764 9.08658 10.8019C9.31204 11.0273 9.6776 11.0273 9.90306 10.8019Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.2634 7.89569C15.157 4.78933 10.1026 4.78933 6.99624 7.89569C6.77078 8.12112 6.77078 8.48668 6.99624 8.71214C7.22167 8.93764 7.58719 8.93757 7.81269 8.71214C10.4689 6.05598 14.7908 6.05598 17.4469 8.71214C17.6724 8.93764 18.0379 8.9376 18.2634 8.71214C18.4889 8.48668 18.4889 8.12111 18.2634 7.89569Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.68334 17.7645C7.00218 17.7645 7.26067 17.506 7.26067 17.1872C7.26067 16.8684 7.00218 16.6099 6.68334 16.6099H4.91815C4.59931 16.6099 4.34082 16.8684 4.34082 17.1872V21.5425C4.34082 21.8613 4.59931 22.1198 4.91815 22.1198C5.23699 22.1198 5.49548 21.8613 5.49548 21.5425V19.9009H6.54313C6.86197 19.9009 7.12046 19.6424 7.12046 19.3236C7.12046 19.0048 6.86197 18.7463 6.54313 18.7463H5.49548V17.7645L6.68334 17.7645Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.183 18.3108C12.183 17.3638 11.3835 16.5933 10.4009 16.5933H9.235C8.90885 16.5933 8.65625 16.8571 8.65625 17.1706V21.558C8.65625 21.8768 8.91474 22.1353 9.23358 22.1353C9.55242 22.1353 9.81091 21.8768 9.81091 21.558V20.3926L11.1723 21.9394C11.3832 22.179 11.7481 22.2018 11.9871 21.9913C12.2264 21.7807 12.2497 21.4159 12.039 21.1765L10.9537 19.9434C11.6665 19.7186 12.183 19.0719 12.183 18.3108ZM10.4009 18.8737C10.2643 18.8737 10.0356 18.8746 9.81721 18.8757C9.8144 18.3152 9.81602 18.4452 9.81405 17.7479H10.4009C10.741 17.7479 11.0283 18.0057 11.0283 18.3108C11.0283 18.6159 10.741 18.8737 10.4009 18.8737Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.9926 17.7684C16.3114 17.7684 16.5699 17.5099 16.5699 17.1911C16.5699 16.8723 16.3114 16.6138 15.9926 16.6138H14.1608C13.842 16.6138 13.5835 16.8723 13.5835 17.1911V21.5385C13.5835 21.8573 13.842 22.1158 14.1608 22.1158H15.9926C16.3114 22.1158 16.5699 21.8573 16.5699 21.5385C16.5699 21.2196 16.3114 20.9611 15.9926 20.9611H14.7382V19.9421H15.8576C16.1764 19.9421 16.4349 19.6836 16.4349 19.3647C16.4349 19.0459 16.1764 18.7874 15.8576 18.7874H14.7382V17.7684L15.9926 17.7684Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.3417 20.9612H19.0873V19.9422H20.2067C20.5255 19.9422 20.784 19.6837 20.784 19.3648C20.784 19.046 20.5255 18.7875 20.2067 18.7875H19.0873V17.7684H20.3417C20.6606 17.7684 20.9191 17.5099 20.9191 17.1911C20.9191 16.8723 20.6606 16.6138 20.3417 16.6138H18.5099C18.1911 16.6138 17.9326 16.8723 17.9326 17.1911V21.5385C17.9326 21.8573 18.1911 22.1158 18.5099 22.1158H20.3417C20.6606 22.1158 20.9191 21.8573 20.9191 21.5385C20.9191 21.2196 20.6606 20.9612 20.3417 20.9612Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.63545 6.49653C9.55753 2.57449 15.7021 2.57449 19.6242 6.49653C19.7369 6.60926 19.8846 6.66565 20.0324 6.66565C20.5421 6.66565 20.8054 6.04483 20.4406 5.68012C16.0753 1.31469 9.18774 1.31134 4.819 5.68008C4.59354 5.90551 4.59354 6.27107 4.819 6.49653C5.04446 6.72199 5.41003 6.72199 5.63545 6.49653Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FreeWifiIcon;
